import React from "react";
import "../../Assets/SCSS/abstracts/icons.scss";
import defaultImage from "Assets/newicons/user-interface/eye-show/outline/eye-show-outline-16px.svg";

export const IconWithBackground = ({
  imgsrc = defaultImage,
  bgColor = "bg-light-blue",
}) => (
  <div className={`icon-bg ${bgColor}`}>
    <img src={imgsrc} className="vertical-center"></img>
  </div>
);

export default IconWithBackground;
